// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regular Typography */
.large_title {
  /* Large Title/Regular */
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 40px;  */
  /* 125% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_1 {
  /* Title 1/Regular */
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 34px;  */
  /* 121.429% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_2 {
  /* Title 2/Regular */
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 28px;  */
  /* 127.273% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_3 {
  /* Title 3/Regular */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 24px; */
  /* 120% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.headline {
  /* Headline/Regular */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 22px;  */
  /* 122.222% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.sub_headline {
  /* Subheadline/Regular */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 20px;  */
  /* 125% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.body {
  /* Body/Regular */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 20px;  */
  /* 142.857% */
  line-height: 1.5;
  letter-spacing: -0.5px;
}

.footnote {
  /* Footnote/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 18px;  */
  /* 138.462% */
  line-height: 1.5;
  letter-spacing: -0.5px;
}

.caption_1 {
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 18px;  */
  /* 138.462% */
  line-height: 1.5;
  letter-spacing: -0.2px;
}

.caption_2 {
  /* Caption 2/Regular */
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 14px;  */
  /* 127.273% */
  line-height: 1.5;
  letter-spacing: -0.2px;
}

/* Bold Typography */
.large_title_bold {
  /* Large Title/Bold */
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 40px;  */
  /* 125% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_1_bold {
  /* Title 1/Bold */
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 34px;  */
  /* 121.429% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_2_bold {
  /* Title 2/Bold */
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 28px; */
  /* 127.273% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.title_3_bold {
  /* Title 3/Bold */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 24px; */
  /* 120% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.headline_bold {
  /* Headline/Bold */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 22px;  */
  /* 122.222% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.sub_headline_bold {
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 20px;  */
  /* 125% */
  line-height: 1.25;
  letter-spacing: -0.5px;
}

.body_bold {
  /* Body/Bold */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 20px; */
  /* 142.857% */
  line-height: 1.5;
  letter-spacing: -0.5px;
}

.footnote_bold {
  /* Footnote/Bold */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 18px;  */
  /* 138.462% */
  line-height: 1.5;
  letter-spacing: -0.5px;
}

.caption_1_bold {
  /* Caption 1/Bold */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 18px;  */
  /* 138.462% */
  line-height: 1.5;
  letter-spacing: -0.2px;
}

.caption_2_bold {
  /* Caption 2/Bold */
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 14px;  */
  /* 127.273% */
  line-height: 1.5;
  letter-spacing: -0.2px;
}

@media screen and (max-width: 1440px) {
  /* .large_title {
  	font-size: 30px;
  }

  .title_1 {
  	font-size: 26px;
  }

  .title_2 {
  	font-size: 20px;
  }

  .title_3 {
  	font-size: 18px;
  }

  .headline {
  	font-size: 16px;
  }

  .sub_headline {
  	font-size: 14px;
  }

  .body {
  	font-size: 13px;
  }

  .footnote {
  	font-size: 12px;
  }

  .caption_1 {
  	font-size: 11px;
  }

  .caption_2 {
  	font-size: 10px;
  } */
  /* Bold Typography  */
  /* .large_title_bold {
  	font-size: 30px;
  }

  .title_1_bold {
  	font-size: 26px;
  }

  .title_2_bold {
  	font-size: 20px;
  }

  .title_3_bold {
  	font-size: 18px;
  }

  .headline_bold {
  	font-size: 16px;
  }

  .sub_headline_bold {
  	font-size: 14px;
  }

  .body_bold {
  	font-size: 13px;
  }

  .footnote_bold {
  	font-size: 12px;
  }

  .caption_1_bold {
  	font-size: 11px;
  }

  .caption_2_bold {
  	font-size: 10px;
  } */
}
@media screen and (max-width: 900px) {
  /* .large_title {
  	font-size: 28px;
  }

  .title_1 {
  	font-size: 24px;
  }

  .title_2 {
  	font-size: 20px;
  }

  .title_3 {
  	font-size: 18px;
  }

  .headline {
  	font-size: 16px;
  }

  .sub_headline {
  	font-size: 14px;
  }

  .body {
  	font-size: 13px;
  }

  .footnote {
  	font-size: 12px;
  }

  .caption_1 {
  	font-size: 11px;
  }

  .caption_2 {
  	font-size: 10px;
  } */
  /* Bold Typography */
  /* .large_title_bold {
  	font-size: 28px;
  }

  .title_1_bold {
  	font-size: 24px;
  }

  .title_2_bold {
  	font-size: 20px;
  }

  .title_3_bold {
  	font-size: 18px;
  }

  .headline_bold {
  	font-size: 16px;
  }

  .sub_headline_bold {
  	font-size: 14px;
  }

  .body_bold {
  	font-size: 13px;
  }

  .footnote_bold {
  	font-size: 12px;
  }

  .caption_1_bold {
  	font-size: 11px;
  }

  .caption_2_bold {
  	font-size: 10px;
  } */
}
@media screen and (max-width: 600px) {
  /* .large_title {
  	font-size: 26px;
  }

  .title_1 {
  	font-size: 22px;
  }

  .title_2 {
  	font-size: 19px;
  }

  .title_3 {
  	font-size: 17px;
  }

  .headline {
  	font-size: 15px;
  }

  .sub_headline {
  	font-size: 14px;
  }

  .body {
  	font-size: 13px;
  }

  .footnote {
  	font-size: 12px;
  }

  .caption_1 {
  	font-size: 11px;
  }

  .caption_2 {
  	font-size: 10px;
  } */
  /* Bold Typography */
  /* .large_title_bold {
  	font-size: 26px;
  }

  .title_1_bold {
  	font-size: 22px;
  }

  .title_2_bold {
  	font-size: 19px;
  }

  .title_3_bold {
  	font-size: 17px;
  }

  .headline_bold {
  	font-size: 15px;
  }

  .sub_headline_bold {
  	font-size: 14px;
  }

  .body_bold {
  	font-size: 13px;
  }

  .footnote_bold {
  	font-size: 12px;
  }

  .caption_1_bold {
  	font-size: 11px;
  }

  .caption_2_bold {
  	font-size: 10px;
  } */
}`, "",{"version":3,"sources":["webpack://./src/styles/typography.css"],"names":[],"mappings":"AAAA,uBAAA;AAEA;EACC,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAAD;;AAGA;EACC,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAAD;;AAGA,oBAAA;AAEA;EACC,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADD;;AAIA;EACC,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADD;;AAIA;EACC,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADD;;AAIA;EACC,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADD;;AAIA;EACC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;EAwCA,qBAAA;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAmCD;AAMA;EACC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;EAwCA,oBAAA;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAgCD;AASA;EACC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;EAwCA,oBAAA;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAAA;AA6BD","sourcesContent":["/* Regular Typography */\n\n.large_title {\n\t/* Large Title/Regular */\n\tfont-family: Poppins;\n\tfont-size: 32px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 40px;  */\n\t/* 125% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_1 {\n\t/* Title 1/Regular */\n\tfont-family: Poppins;\n\tfont-size: 28px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 34px;  */\n\t/* 121.429% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_2 {\n\t/* Title 2/Regular */\n\tfont-family: Poppins;\n\tfont-size: 22px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 28px;  */\n\t/* 127.273% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_3 {\n\t/* Title 3/Regular */\n\tfont-family: Poppins;\n\tfont-size: 20px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 24px; */\n\t/* 120% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.headline {\n\t/* Headline/Regular */\n\tfont-family: Poppins;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 22px;  */\n\t/* 122.222% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.sub_headline {\n\t/* Subheadline/Regular */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 20px;  */\n\t/* 125% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.body {\n\t/* Body/Regular */\n\tfont-family: Poppins;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\t/* line-height: 20px;  */\n\t/* 142.857% */\n\tline-height: 1.5;\n\tletter-spacing: -0.5px;\n}\n\n.footnote {\n\t/* Footnote/Regular */\n\tfont-family: Poppins;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\t/* line-height: 18px;  */\n\t/* 138.462% */\n\tline-height: 1.5;\n\tletter-spacing: -0.5px;\n}\n\n.caption_1 {\n\t/* Caption 1/Regular */\n\tfont-family: Poppins;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\t/* line-height: 18px;  */\n\t/* 138.462% */\n\tline-height: 1.5;\n\tletter-spacing: -0.2px;\n}\n\n.caption_2 {\n\t/* Caption 2/Regular */\n\tfont-family: Poppins;\n\tfont-size: 11px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\t/* line-height: 14px;  */\n\t/* 127.273% */\n\tline-height: 1.5;\n\tletter-spacing: -0.2px;\n}\n\n/* Bold Typography */\n\n.large_title_bold {\n\t/* Large Title/Bold */\n\tfont-family: Poppins;\n\tfont-size: 32px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 40px;  */\n\t/* 125% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_1_bold {\n\t/* Title 1/Bold */\n\tfont-family: Poppins;\n\tfont-size: 28px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 34px;  */\n\t/* 121.429% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_2_bold {\n\t/* Title 2/Bold */\n\tfont-family: Poppins;\n\tfont-size: 22px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 28px; */\n\t/* 127.273% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.title_3_bold {\n\t/* Title 3/Bold */\n\tfont-family: Poppins;\n\tfont-size: 20px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 24px; */\n\t/* 120% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.headline_bold {\n\t/* Headline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 22px;  */\n\t/* 122.222% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.sub_headline_bold {\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\t/* line-height: 20px;  */\n\t/* 125% */\n\tline-height: 1.25;\n\tletter-spacing: -0.5px;\n}\n\n.body_bold {\n\t/* Body/Bold */\n\tfont-family: Poppins;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 20px; */\n\t/* 142.857% */\n\tline-height: 1.5;\n\tletter-spacing: -0.5px;\n}\n\n.footnote_bold {\n\t/* Footnote/Bold */\n\tfont-family: Poppins;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 18px;  */\n\t/* 138.462% */\n\tline-height: 1.5;\n\tletter-spacing: -0.5px;\n}\n\n.caption_1_bold {\n\t/* Caption 1/Bold */\n\tfont-family: Poppins;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 18px;  */\n\t/* 138.462% */\n\tline-height: 1.5;\n\tletter-spacing: -0.2px;\n}\n\n.caption_2_bold {\n\t/* Caption 2/Bold */\n\tfont-family: Poppins;\n\tfont-size: 11px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 14px;  */\n\t/* 127.273% */\n\tline-height: 1.5;\n\tletter-spacing: -0.2px;\n}\n\n@media screen and (max-width: 1440px) {\n\t/* .large_title {\n\t\tfont-size: 30px;\n\t}\n\n\t.title_1 {\n\t\tfont-size: 26px;\n\t}\n\n\t.title_2 {\n\t\tfont-size: 20px;\n\t}\n\n\t.title_3 {\n\t\tfont-size: 18px;\n\t}\n\n\t.headline {\n\t\tfont-size: 16px;\n\t}\n\n\t.sub_headline {\n\t\tfont-size: 14px;\n\t}\n\n\t.body {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1 {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2 {\n\t\tfont-size: 10px;\n\t} */\n\n\t/* Bold Typography  */\n\n\t/* .large_title_bold {\n\t\tfont-size: 30px;\n\t}\n\n\t.title_1_bold {\n\t\tfont-size: 26px;\n\t}\n\n\t.title_2_bold {\n\t\tfont-size: 20px;\n\t}\n\n\t.title_3_bold {\n\t\tfont-size: 18px;\n\t}\n\n\t.headline_bold {\n\t\tfont-size: 16px;\n\t}\n\n\t.sub_headline_bold {\n\t\tfont-size: 14px;\n\t}\n\n\t.body_bold {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote_bold {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1_bold {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2_bold {\n\t\tfont-size: 10px;\n\t} */\n}\n\n@media screen and (max-width: 900px) {\n\t/* .large_title {\n\t\tfont-size: 28px;\n\t}\n\n\t.title_1 {\n\t\tfont-size: 24px;\n\t}\n\n\t.title_2 {\n\t\tfont-size: 20px;\n\t}\n\n\t.title_3 {\n\t\tfont-size: 18px;\n\t}\n\n\t.headline {\n\t\tfont-size: 16px;\n\t}\n\n\t.sub_headline {\n\t\tfont-size: 14px;\n\t}\n\n\t.body {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1 {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2 {\n\t\tfont-size: 10px;\n\t} */\n\n\t/* Bold Typography */\n\n\t/* .large_title_bold {\n\t\tfont-size: 28px;\n\t}\n\n\t.title_1_bold {\n\t\tfont-size: 24px;\n\t}\n\n\t.title_2_bold {\n\t\tfont-size: 20px;\n\t}\n\n\t.title_3_bold {\n\t\tfont-size: 18px;\n\t}\n\n\t.headline_bold {\n\t\tfont-size: 16px;\n\t}\n\n\t.sub_headline_bold {\n\t\tfont-size: 14px;\n\t}\n\n\t.body_bold {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote_bold {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1_bold {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2_bold {\n\t\tfont-size: 10px;\n\t} */\n}\n\n@media screen and (max-width: 600px) {\n\t/* .large_title {\n\t\tfont-size: 26px;\n\t}\n\n\t.title_1 {\n\t\tfont-size: 22px;\n\t}\n\n\t.title_2 {\n\t\tfont-size: 19px;\n\t}\n\n\t.title_3 {\n\t\tfont-size: 17px;\n\t}\n\n\t.headline {\n\t\tfont-size: 15px;\n\t}\n\n\t.sub_headline {\n\t\tfont-size: 14px;\n\t}\n\n\t.body {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1 {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2 {\n\t\tfont-size: 10px;\n\t} */\n\n\t/* Bold Typography */\n\n\t/* .large_title_bold {\n\t\tfont-size: 26px;\n\t}\n\n\t.title_1_bold {\n\t\tfont-size: 22px;\n\t}\n\n\t.title_2_bold {\n\t\tfont-size: 19px;\n\t}\n\n\t.title_3_bold {\n\t\tfont-size: 17px;\n\t}\n\n\t.headline_bold {\n\t\tfont-size: 15px;\n\t}\n\n\t.sub_headline_bold {\n\t\tfont-size: 14px;\n\t}\n\n\t.body_bold {\n\t\tfont-size: 13px;\n\t}\n\n\t.footnote_bold {\n\t\tfont-size: 12px;\n\t}\n\n\t.caption_1_bold {\n\t\tfont-size: 11px;\n\t}\n\n\t.caption_2_bold {\n\t\tfont-size: 10px;\n\t} */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
